import { render, staticRenderFns } from "./baojiadan.vue?vue&type=template&id=7debd48e"
import script from "./baojiadan.vue?vue&type=script&lang=js"
export * from "./baojiadan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports